import React, { createContext, useState, useContext, useEffect } from 'react';
import { getTokenData } from '../services/authService';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Завжди пріоритет localStorage - це запобігає конфліктам
    const savedTheme = localStorage.getItem('userTheme');
    if (savedTheme) {
      return savedTheme;
    }
    
    // Якщо немає збереженої теми, перевіряємо токен
    const tokenData = getTokenData();
    const themeFromToken = tokenData?.theme || 'light';
    
    // Зберігаємо в localStorage
    localStorage.setItem('userTheme', themeFromToken);
    return themeFromToken;
  });

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    
    // Зберігаємо тему тільки в localStorage
    localStorage.setItem('userTheme', newTheme);
  };

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}; 